<!-- 课酬管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-select v-model="queryParams.month" clearable placeholder="选择月份" class="label">
                        <el-option v-for="item in monthList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.type" clearable placeholder="" class="label">
                        <el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="教师确认状态" class="label">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
					<el-input v-model="queryParams.name" placeholder="请输入教师姓名"></el-input>
				</el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<!-- <el-button type="primary" style="margin-left:20px" size="small" @click='exportFun()'>导出</el-button> -->
                </el-form-item>
            </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="month" label="月份" align="center">
                    </el-table-column>
					<el-table-column prop="name" label="教师姓名" align="center">
                    </el-table-column>
                    <el-table-column prop="form" label="教师来源" align="center">
                    </el-table-column>
                    <el-table-column prop="attendance" label="已出勤次数" align="center">
                    </el-table-column>
                    <el-table-column prop="wage" label="服务工资合计" align="center">
                    </el-table-column>
                    <el-table-column prop="state" label="教师确认状态" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{
        Detail: ()=>import('./detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 10,
			queryParams: {
				month: '',
				type:'0',
				state: '',
				class: '',
			},
			monthList:	[
				{id:'01',label:'01月'},
				{id:'02',label:'02月'},
				{id:'03',label:'03月'},
				{id:'04',label:'04月'},
				{id:'05',label:'05月'},
				{id:'06',label:'06月'},
				{id:'07',label:'07月'},
				{id:'08',label:'08月'},
				{id:'09',label:'09月'},
				{id:'10',label:'10月'},
				{id:'11',label:'11月'},
				{id:'12',label:'12月'},
			],	// 月份列表
			typeList: [{id:'0',label:'全部教师'},{id:'1',label:'校内教师'},{id:'2',label:'机构教师'}],
			stateList: [{id:'1',label:'已确认'},{id:'2',label:'未确认'}],
			tableData: [

				{month:'2月',name:'王恩龙',form:'本校教师	  ',attendance:'20',wage:'￥1,000.00 ',state:'已确认'},
				{month:'2月',name:'朱政廷',form:'机构教师-智课',attendance:'30',wage:'￥1,200.00 ',state:'待确认'},
				{month:'2月',name:'邓诗涵',form:'本校教师	  ',attendance:'30',wage:'￥1,200.00 ',state:'待确认'},
				{month:'2月',name:'陈政倩',form:'本校教师	  ',attendance:'30',wage:'￥1,200.00 ',state:'已确认'},
				{month:'2月',name:'吴俊伯',form:'机构教师-智课',attendance:'20',wage:'￥1,000.00 ',state:'已确认'},
				{month:'2月',name:'阮馨学',form:'本校教师	  ',attendance:'35',wage:'￥1,300.00 ',state:'待确认'},
				{month:'2月',name:'翁惠珠',form:'本校教师	  ',attendance:'35',wage:'￥1,300.00 ',state:'已确认'},
				{month:'2月',name:'吴思輸',form:'本校教师	  ',attendance:'20',wage:'￥1,000.00 ',state:'已确认'},
				{month:'2月',name:'林佩玲',form:'机构教师-巨人',attendance:'20',wage:'￥1,000.00 ',state:'待确认'},
				{month:'2月',name:'邓海来',form:'本校教师	  ',attendance:'30',wage:'￥1,200.00 ',state:'已确认'},
			],
            detail:{
                info:{title:'赵兵 9月课酬详情'},
                show:false,
            },
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			// this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
		exportFun(){},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
